// funciones para traducir pdf -inicio-//
const base64ToArrayBuffer = (base64) => {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };
  
  const saveByteArray = (reportName, byte) => {
    var blob = new Blob([byte], {type: 'application/pdf'})
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE ...maldito...
        window.navigator.msSaveOrOpenBlob(blob, reportName);
    } else { // for Non-IE (chrome, firefox etc.)
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      var fileName = reportName
      link.download = fileName
      link.click()
    }
  }
  function downloadPDF (response, nombre)   {
    const arr = base64ToArrayBuffer(response.data);
    saveByteArray(nombre, arr);
  }
  // funciones para traducir pdf -fin-///

  export default {
    downloadPDF
  }